import { Label } from '@/shared/ui/label';
import { Input } from '@/shared/ui/input';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Aviso quando bonificação está ligada sem Passbook. */
  warnBonusWithoutPassbook?: boolean;
  id?: string;
}

export function PassbookIdField({
  value,
  onChange,
  disabled,
  warnBonusWithoutPassbook,
  id = 'passbook-id',
}: Props) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>ID Passbook do cliente</Label>
      <Input
        id={id}
        value={value}
        disabled={disabled}
        placeholder="ObjectId do passbook no legado"
        onChange={(e) => onChange(e.target.value)}
        className="font-mono"
      />
      <p className="text-xs text-muted-foreground">
        {disabled
          ? 'Vem da conta do usuário e não é editado aqui.'
          : 'Liga a marca à fidelidade, ao Metabase e ao dashboard no login.'}
      </p>
      {warnBonusWithoutPassbook && !value ? (
        <p className="text-xs text-warning">
          Pesquisa bonificada exige Passbook no usuário da marca — sem isso os pontos não são creditados.
        </p>
      ) : null}
    </div>
  );
}
